import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@playerbase/ui';

import { useAuth } from '../auth/use-auth.js';
import { StudioSetupForm } from '../studios/studio-setup-form.js';

export function NewStudioPage(): JSX.Element {
  const { studios, activeStudioId, setActiveStudioId, refreshMemberships } = useAuth();
  const navigate = useNavigate();

  // Cancel takes the user back to whichever studio they came from. Falls back
  // to studios[0] (the same fallback RootRedirect uses) if the active id has
  // somehow drifted, or to '/' if they have no studios at all (which is
  // unreachable here because ProtectedRoute would have routed them away).
  const cancelTarget =
    studios.find((s) => s.id === activeStudioId)?.shortId ?? studios[0]?.shortId ?? null;

  return (
    <div className="mx-auto max-w-2xl px-4 py-10 sm:px-6">
      <header className="mb-6">
        <p className="font-mono text-[10px] uppercase tracking-wider text-text-muted">
          New studio
        </p>
        <h1 className="mt-2 font-display text-2xl font-bold text-text">
          Create a studio
        </h1>
        <p className="mt-2 text-sm text-text-muted">
          A studio is a workspace for one team. You can switch between studios
          you belong to from the sidebar at any time.
        </p>
      </header>

      <StudioSetupForm
        initialName=""
        submitLabel="Create studio"
        submittingLabel="Creating…"
        onCreated={async (created) => {
          // Pin the new studio active BEFORE refreshing memberships so the
          // shell renders into it rather than the previously-active one mid
          // navigation.
          setActiveStudioId(created.id);
          await refreshMemberships();
          navigate(`/s/${created.shortId}`, { replace: true });
        }}
      />

      {cancelTarget !== null && (
        <div className="mt-4 flex justify-center">
          <Button asChild variant="ghost" size="md">
            <Link to={`/s/${cancelTarget}`}>Cancel</Link>
          </Button>
        </div>
      )}
    </div>
  );
}
